// 서버 시각 문자열 → 한국시간 표시 (2026-10-06 사장님: 파트너 페이지 시간 오표시 수정)
// 백엔드 DB 는 테이블마다 저장 기준이 다름(일부 KST 벽시계, 일부 UTC). 브라우저(KST)에서 `new Date("2026-10-05T21:30:00")` 처럼
// 시간대 표기가 없는 문자열은 '로컬(KST)' 로 해석되므로 KST 저장 컬럼은 그대로 맞지만, UTC 저장 컬럼은 9시간 빠르게 보인다.
// → UTC 저장 컬럼(inquiries.created_at/replied_at, partner_withdrawals.created_at/processed_at, partners.created_at 등)은
//   이 헬퍼로 'Z' 를 붙여 UTC 로 파싱한 뒤 Asia/Seoul 로 표시한다. KST 저장 컬럼엔 쓰지 말 것(9시간 늦어짐).

const HAS_TZ = /(Z|[+-]\d{2}:?\d{2})$/

/** 시간대 표기 없는 ISO 문자열을 UTC 로 간주해 Date 로 변환 */
export const parseUtcNaive = (s?: string | null): Date | null => {
  if (!s) return null
  const d = new Date(HAS_TZ.test(s) ? s : `${s}Z`)
  return isNaN(d.getTime()) ? null : d
}

/** UTC 저장 컬럼 → 한국시간 'YYYY. MM. DD. HH:mm' 형식(locale 기본) */
export const fmtUtcToKst = (s: string | null | undefined, locale: string = 'ko-KR',
                            opts: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }): string => {
  const d = parseUtcNaive(s)
  return d ? d.toLocaleString(locale, { ...opts, timeZone: 'Asia/Seoul' }) : '-'
}

/** UTC 저장 컬럼 → 한국 날짜만 */
export const fmtUtcToKstDate = (s: string | null | undefined, locale: string = 'ko-KR'): string =>
  fmtUtcToKst(s, locale, { year: 'numeric', month: '2-digit', day: '2-digit' })
